import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useState, Suspense } from 'react'
import { ErrorBoundary } from '@rollbar/react'
import classNames from 'classnames'
import Header from 'components/Header/Header'
import Menu from '../components/Menu/Menu'
import Arrow from 'components/assets/icons/Arrow'
import { pages, GetPageIndex } from 'components/RCPro/helpers/nav'
import { PriceProvider } from '../components/Context/Context'
import style from './Wrapper.module.scss'
import PoweredBy from 'components/assets/icons/PoweredBy'

const Wrapper = () => {
  const navigate = useNavigate()
  const { state, pathname } = useLocation()
  const pageIndex = GetPageIndex()
  const [ previousPage, setPreviousPage ] = useState(false)
  const [ nextPage, setNextPage ] = useState(false)
  const [ partnerLogo, setPartnerLogo ] = useState(state?.texts ? state.texts.logo : 'loading')
  const project = pathname.split('/')[1]

  // Infobulles
  const getMessages = () => {
    const oldesIndex = pageIndex - 3 < 0 ? 0 : pageIndex - 3
    return state?.texts.infobulles?.slice(oldesIndex, pageIndex)
  }

  // Transition to previous page
  const previousPageTransition = () => {
    localStorage.setItem(project === 'rc-pro' ? 'RCPro' : project, JSON.stringify({ page: pages[pageIndex-1], savedState: state }))
    setPreviousPage(true)
    setTimeout( () => navigate('./'+pages[pageIndex-1], { state }), 250)
    setTimeout( () => setPreviousPage(false), 500)
  }

  // Transition to next page
  const nextPageTransition = () => {
    setNextPage(true)
    setTimeout( () => setNextPage(false), 500)
  }


  return pageIndex > 0 && !state
  ? <Navigate to={`/${project}/${(project === 'rc-pro' ? process.env.REACT_APP_RCPRO_URL : process.env.REACT_APP_RCA_URL)}`} replace />
  : (
    <Suspense fallback={<div />} >
      <ErrorBoundary
        fallbackUI={({ error }) => {
          console.log('error boundary : '+error)
          window.location.replace(`/${project}/${(project === 'rc-pro' ? process.env.REACT_APP_RCPRO_URL : process.env.REACT_APP_RCA_URL).split('?')[0]}/oups?reason=401`)
          return <></>
        }}
      >
        <PriceProvider>
          <div className={style.bg}>
            {partnerLogo !== 'loading' && <Header
              logo={partnerLogo &&
                <div className={style.cobranding}>
                  <span dangerouslySetInnerHTML={{__html: partnerLogo}}></span>
                  <PoweredBy />
                </div>
              }
              hideRightSide={true}
              lightBg={true}
            />}

            {![0, 6, 7, 8].includes(pageIndex) && 
              <Menu texts={{
                menu1: state?.texts['menu 1'],
                menu2: state?.texts['menu 2']
              }} />
            }

            <main className={classNames(
              style.content,
              (pageIndex === 0 || pageIndex > 6) && style.singleBloc,
              pageIndex === 8 && style.estimate,
              previousPage && style.previousPage,
              nextPage && style.nextPage
            )}>
              <div>
                {![0, 1, 7, 8].includes(pageIndex) &&
                  <span className={style.back} onClick={previousPageTransition}>
                    <Arrow/> Retour
                  </span>
                }
                <Outlet context={{nextPageTransition, setPartnerLogo}} />
              </div>
            </main>

            {(pageIndex > 0 && pageIndex < 7) && 
              <aside className={classNames(
                style.chat,
                previousPage && style.previousPage,
                nextPage && style.nextPage
              )}>
                <ul>
                  {
                    getMessages()?.map( (msg, index) => (
                      msg && <li key={`msg-${index}`}>
                        <header>{msg.title}</header>
                        <p>{msg.message}</p>
                      </li>
                    ))
                  }
                </ul>
              </aside>
            }
          </div>
        </PriceProvider>
      </ErrorBoundary>
    </Suspense>
  )
}

export default Wrapper